const MAX_LENGTH = {
  postTitle: 100,
  comment: 600,
  postLink: 600,
};

export default MAX_LENGTH;
